const emptyConfiguration  = {
    'Id': 0,
    'Name': '',
    'FromEmailAddress': '',
    'ToEmailAddress': '',
    'EmailSubjectPrefix': '',
    'SynchronizerUrl': null,
    'HostName': '',
    'Port': 465,
    'TimeoutInSeconds': 30,
    'UseSSL': false,
    'UserName': '',
    'Password': ''
};

export default class SmtpConfigurationService {
    constructor(http) {
        this.http = http;
    }

    fetchConfiguration() {
        return new Promise((resolve, reject) => {
            this.http.get(this.backendUrl + '/notifications/smtp-configuration').then(
                (response) => {
                    if (response.status === 200 && response.data) {
                        resolve(response.data);
                    }
                },
                (err) => {
                    reject(err);
                }
            );
        });
    }

    saveConfiguration(configuration) {
        return new Promise((resolve, reject) => {
            this.http.post(this.backendUrl + '/notifications/smtp-configuration', configuration).then(
                (response) => {
                    if (response.status === 200 && response.data) {
                         setTimeout(function() {
                            resolve(response.data);
                        }, 500);

                    }
                },
                (err) => {
                    reject(err);
                }
            );
        });
    }

    testConfiguration(configuration) {
        return new Promise((resolve, reject) => {
            this.http.post(this.backendUrl + '/notifications/smtp-configuration/test', configuration).then(
                (response) => {
                    if (response.status === 204) {
                        resolve();
                    }
                },
                (err) => {
                    reject(err);
                }
            );
        });
    }

    removeConfiguration(configurationId) {
        return new Promise((resolve, reject) => {
            this.http.delete(this.backendUrl + '/notifications/smtp-configuration/' + configurationId).then(
                (response) => {
                    if (response.status === 204) {
                      resolve(emptyConfiguration);
                    }
                },
                (err) => {
                    reject(err);
                }
            );
        });
    }

    disableConfiguration(configurationId) {
        return new Promise((resolve, reject) => {
            this.http.post(this.backendUrl + '/notifications/smtp-configuration/' + configurationId + '/disable').then(
                (response) => {
                    if (response.status === 204) {
                        resolve();
                    }
                },
                (err) => {
                    reject(err);
                }
            );
        });
    }

    enableConfiguration(configurationId) {
        return new Promise((resolve, reject) => {
            this.http.post(this.backendUrl + '/notifications/smtp-configuration/' + configurationId + '/enable').then(
                (response) => {
                    if (response.status === 204) {
                        resolve();
                    }
                },
                (err) => {
                    reject(err);
                }
            );
        });
    }
}



// WEBPACK FOOTER //
// ./src/service/smtpConfiguration.js